<template>
    <div>
      <section v-if="isLoading">Loading..</section>
      <table class="table table-striped dataTable" id="datatable" v-else>
        <thead>
          <tr>
            <th>Calendar Code</th>
            <th>Code Description</th>
            <th>Number of Days</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="legend in calendarlegends"
            :key="legend.calendarAttendanceTypeId">
            <td class="print-big">{{ legend.Code }}</td>
            <td class="print-big">{{ legend.Description }}</td>
            <td class="print-big">{{ legend.Count }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
   
  <script>
  import Constants from "../utilities/Constants.js";
  import "jquery/dist/jquery.min.js";
  import "bootstrap/dist/css/bootstrap.min.css";
  import "datatables.net-dt/js/dataTables.dataTables";
  import "datatables.net-dt/css/jquery.dataTables.min.css";
  import axios from "axios";
  import $ from "jquery";
  
  export default {
    mounted() {
      let WebURL = "";
      WebURL = `${Constants.API_URL}/api/PFSearchApi/GetLatestCalendarMainId?schoolYear=${this.$route.params.year}&progEntityId=${this.$route.params.id}`;
      axios.get(WebURL).then((res) => {
        this.latestCalendarMainId = res.data[0].CalendarMainId;
  
        WebURL = `${Constants.API_URL}/api/PFSearchApi/GetCalendarLegend?calendarMainId=${this.latestCalendarMainId}`;
        this.isLoading = true;
        //API Call
        axios
          .get(WebURL)
          .then((res) => {
            this.calendarlegends = res.data;
            $("#datatable").DataTable();
          })
          .then(() => {
            this.isLoading = false;
          });
      });
    },
    data: function () {
      return {
        calendarlegends: [],
        isLoading: false,
      };
    },
  };
  </script>